export const achievementData = {
    bio: "",
    achievements: [
        {
            id: 1,
            title: 'Agile Project Management ',
            details: 'University of Winnipeg (PACE) | Winnipeg',
            date: '',
            field: '',
        },
        {
            id: 2,
            title: 'Certified Ethical Hacking (CEH)',
            details: 'IT Training Nepal | Kathmandu, Nepal',
            date: '',
            field: '',
        },
        {
            id: 3,
            title: 'Building Dynamic Websites, SQL Server, Dreamweaver',
            details: 'APTECH Computer Education| Kathmandu, Nepal',
            date: '',
            field: '',
        },
        {
            id: 4,
            title: 'Information Systems Management ',
            details: 'APTECH Computer Education | Kathmandu, Nepal',
            date: '',
            field: '',
        },
        {
            id: 5,
            title: 'Network Engineer',
            details: 'APTECH Computer Education | Kathmandu, Nepal',
            date: '',
            field: '',
        },

        {
            id: 7,
            title: 'Relational Database Management Systems',
            details: 'NIIT | Bangalore, India',
            date: '',
            field: '',
        },
        {
            id: 8,
            title: 'Object-Oriented Programming Using C#',
            details: 'NIIT | Bangalore, India',
            date: '',
            field: '',
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/
